import { Navigate, Outlet } from 'react-router-dom';

function AdminRoute() {
  const adminToken = localStorage.getItem('admin_token');
  console.log('Current admin token:', adminToken ? 'exists' : 'missing');

  // Redirect if no token found
  if (!adminToken) {
    console.log('No admin token found, redirecting to login');
    return <Navigate to="/admin/login" replace />;
  }

  // Allow access to child routes
  return <Outlet />;
}

export default AdminRoute;